import React, { useState, useRef, useEffect } from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
  Grid,
  Box,
  IconButton,
  useMediaQuery,
  Chip,
  Snackbar,
  SnackbarContent,
  Alert,
  Modal,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

import { ArrowBackIos, ArrowForwardIos, Star } from "@mui/icons-material";
import { useSelector, useDispatch } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { useFetch } from "../../hooks";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import {
  addToCart,
  addProductToStore,
  setModalProperties,
  updateCartQuantity,
  removeFromCart,
} from "../../store/actions/userActions";
import { Select, MenuItem } from "@mui/material";
import configureStore from "../../store";
import ProductCardWithZoom from "../Modal/prodcutCardWithZoom";

const { store, persistor } = configureStore();
// Product Card Component

const ProductCard = ({ product, onItemAdded, onImageClick }) => {
  const cartItemsDetails = useSelector(
    (state) => state.user?.cartDetails || [],
  );

  console.log("product Productlsit", product?.product_name);

  const cartItems = Array.isArray(cartItemsDetails.items)
    ? cartItemsDetails.items
    : [];
  const [calculatedPrice, setCalculatedPrice] = useState({
    salePrice: Number(product.salePrice),
    regularPrice: Number(product.regularPrice),
  });
  const [zoomPosition, setZoomPosition] = useState();
  const [showProductZoomModal, setShowProductZooModal] = useState();
  const dispatch = useDispatch();
  // Find this product in Redux cart using vendor_product_id
  const cartItem = cartItems.find(
    (item) => item.vendor_product_id === product?.vendor_product_id?.toString(),
  );

  const [isAdded, setIsAdded] = useState(cartItem ? true : false);
  const [count, setCount] = useState(cartItem?.quantity || 1);
  const [buttonColor, setButtonColor] = useState("#038100");
  const cartStore = useSelector((store) => store.user);
  // const data = location.state;
  const data = cartStore["productDetails"];

  const handleAdd = () => {
    setCount(1);
    onItemAdded(
      product.title,
      product.price,
      product.discount,
      product.images,
      1,
    );
    setButtonColor("#ff9800");
  };

  const increaseItem = (item) => {
    const maxStock = item?.stock_quantity || 999;
    console.log("maxStock", maxStock);
    // Check stock limit
    if (count >= maxStock) {
      dispatch(
        setModalProperties({
          showModal: true,
          modalMessage: `Cannot add more. Only ${maxStock} items available in stock.`,
        }),
      );
      return; // Return ONLY if stock limit reached
    }

    // If stock is available, proceed to increase
    const newQuantity = count + 1;
    setCount(newQuantity);
    const vendorProductId = product?.vendor_product_id?.toString() || "0";
    dispatch(updateCartQuantity(vendorProductId, newQuantity));
  };

  const decreaseItem = (item) => {
    const vendorProductId = item?.vendor_product_id?.toString();

    if (count > 1) {
      const newQuantity = count - 1;
      setCount(newQuantity);
      dispatch(updateCartQuantity(vendorProductId, newQuantity));
    } else if (count === 1) {
      setIsAdded(false);
      setCount(1);
      dispatch(removeFromCart(vendorProductId));
    }
  };

  const addProductToCart = (
    buttonType = "",
    product,
    selectedVariants = {},
  ) => {
    const state = store.getState();
    const existingCartData = state.user?.cartDetails?.items
      ? state.user.cartDetails.items
      : [];

    const cartItem = state.user;
    console.log("cartItem", cartItem);
    console.log("product selected", product, existingCartData);
    const productId = product?.product_id?.toString() || "0";
    const vendorId = product?.vendor_id?.toString() || "0";
    const productTitle = product?.product_name
      ? product?.product_name
      : product?.name || "";
    // const productPrice = product?.salePrice || "0.00";
    // const originalPrice = product?.regularPrice || "0.00";
    const productPrice = calculatedPrice.salePrice;
    const originalPrice = calculatedPrice.regularPrice;
    const productDiscount = product?.discount || 0;
    const productImages = product?.images?.map((img) => img.image_url) || [];
    const vendorProductId = product?.vendor_product_id?.toString();
    const variantOptionIdString = Object.values(selectedVariants)
      .map((v) => v.variant_option_id)
      .join(",");

    const selectedVariantDetails = Object.entries(selectedVariants).map(
      ([variant_id, { option_name, variant_option_id }]) => ({
        variant_id: Number(variant_id),
        option_name,
        variant_option_id,
      }),
    );

    const newItem = {
      product_id: productId,
      vendor_id: vendorId,
      title: productTitle,
      quantity: 1,
      // price: parseFloat(productPrice).toFixed(2),
      // originalPrice: parseFloat(originalPrice).toFixed(2),
      price: parseFloat(productPrice).toFixed(2),
      originalPrice: parseFloat(originalPrice).toFixed(2),
      discount: productDiscount,
      additionalProducts: [],
      images: productImages,
      variantOptionId: variantOptionIdString,
      selectedVariants: selectedVariantDetails,
      vendor_product_id: vendorProductId,
    };

    console.log("newItem", newItem);
    // Clone existing cart
    const existingCart = Array.isArray(existingCartData)
      ? [...existingCartData]
      : [];

    // const productIndex = existingCart.findIndex(
    //   (item) => item.vendor_product_id === newItem.vendor_product_id,
    // );

    const productIndex = existingCart.findIndex(
      (item) =>
        item.vendor_product_id === newItem.vendor_product_id &&
        item.variantOptionId === newItem.variantOptionId,
    );
    console.log("productIndex", productIndex, existingCart);

    if (productIndex > -1) {
      // Already exists → increase quantity
      existingCart[productIndex].quantity += 1;
    } else {
      // Add as new item
      existingCart.push(newItem);
      console.log("existingCart", existingCart);
    }

    console.log("existingCart oushed", existingCart);

    // Deduplicate cart items by vendor_product_id to prevent duplicates
    const deduplicatedCart = Array.from(
      new Map(
        existingCart.map((item) => [item.vendor_product_id, item]),
      ).values(),
    );

    // Compute total price
    const total = deduplicatedCart.reduce(
      (sum, item) =>
        sum + parseFloat(item.price) * (parseInt(item.quantity) || 1),
      0,
    );
    console.log("deduplicatedCart", deduplicatedCart);
    console.log("Final Cart State (items):", deduplicatedCart);
    console.log("Total: ₹", total.toFixed(2));
    // Dispatch
    dispatch(addToCart({ item: deduplicatedCart, modification: false }));

    const itemList = deduplicatedCart
      .map((item) => `• ${item.title}`)
      .join("\n");

    const totalAmount = deduplicatedCart.reduce(
      (sum, item) => sum + parseFloat(item.price) * item.quantity,
      0,
    );

    // Show Snackbar
    dispatch(
      setModalProperties({
        showModal: true,
        modalMessage: `${existingCart.length} ${
          existingCart.length === 1 ? "item" : "items"
        } added to cart:\n${itemList}\n\nTotal: ₹${totalAmount.toFixed(2)}`,
      }),
    );

    // Navigate if direct buy
    if (buttonType === "Buy") {
      // navigate("/checkoutpage");
    }
  };

  const handleMouseMove = (e) => {
    const { offsetX, offsetY, target } = e.nativeEvent;

    const { width, height } = target.getBoundingClientRect();

    const x = (offsetX / width) * 100;
    const y = (offsetY / height) * 100;

    setZoomPosition({ x, y });
  };

  const handleMouseLeave = () => {
    setZoomPosition(null);
  };

  const handleOnclose = (value) => {
    setShowProductZooModal(value);
  };

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedVariants, setSelectedVariants] = useState({});

  // const handleVariantChange = (variantId, variantData) => (event) => {
  //   const selectedOption = JSON.parse(event.target.value);

  //   const selectedOptionObj = product.variantData
  //     .find((variant) => variant.variant_id === variantId)
  //     ?.options.find(
  //       (option) =>
  //         option.variant_option_id === selectedOption.variant_option_id,
  //     );

  //      console.log("selectedOption", selectedOptionObj,variantData);
  //   setSelectedVariants((prev) => ({
  //     ...prev,
  //     [variantId]: {
  //       option_name:
  //         selectedOptionObj?.option_name || selectedOption.option_name,
  //       variant_option_id:
  //         selectedOptionObj?.variant_option_id ||
  //         selectedOption.variant_option_id,
  //     },
  //   }));
  // };

  const handleVariantChange = (variantId) => (event) => {
    const selectedOption = JSON.parse(event.target.value);

    const selectedOptionObj = product.variantData
      .find((variant) => variant.variant_id === variantId)
      ?.options.find(
        (option) =>
          option.variant_option_id === selectedOption.variant_option_id,
      );

    const optionName =
      selectedOptionObj?.option_name || selectedOption.option_name;

    setSelectedVariants((prev) => ({
      ...prev,
      [variantId]: {
        option_name: optionName,
        variant_option_id:
          selectedOptionObj?.variant_option_id ||
          selectedOption.variant_option_id,
      },
    }));

    // Calculate multiplier
    // const multiplier = parseInt(optionName);
    const multiplier = Number(optionName.replace(/[^\d.]/g, ""));

    if (!isNaN(multiplier)) {
      setCalculatedPrice({
        salePrice: Number(product.salePrice) * multiplier,
        regularPrice: Number(product.regularPrice) * multiplier,
      });
    }
  };

  useEffect(() => {
    console.log("selectedVariants", selectedVariants);
  }, [selectedVariants]);

  useEffect(() => {
    if (!product?.vendor_product_id) return; // guard against undefined

    if (cartItem && cartItem.quantity > 0) {
      setIsAdded(true);
      setCount(cartItem.quantity);
      // Restore selected variants from cart
      if (cartItem.selectedVariants && cartItem.selectedVariants.length > 0) {
        const variantsMap = {};
        cartItem.selectedVariants.forEach((variant) => {
          variantsMap[variant.variant_id] = {
            option_name: variant.option_name,
            variant_option_id: variant.variant_option_id,
          };
        });
        setSelectedVariants(variantsMap);
      }
    } else {
      // Only reset if this product is genuinely NOT in cart
      const stillInCart = cartItems.some(
        (item) =>
          String(item.vendor_product_id) === String(product?.vendor_product_id),
      );
      if (!stillInCart) {
        setIsAdded(false);
        setCount(1);
        setSelectedVariants({});
      }
    }
  }, [
    cartItem?.quantity,
    cartItem?.vendor_product_id,
    cartItem?.selectedVariants,
  ]); // ← depend on specific fields, not entire object

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedProduct(null);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FFFFFF",
        borderRadius: "12px",
        overflow: "hidden",
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        height: "100%",
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
        "&:hover": {
          transform: "translateY(-5px)",
          boxShadow: "0 8px 16px rgba(0,0,0,0.12)",
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          backgroundColor: "#f5f5f5",
          padding: "12px",
        }}
      >
        <Chip
          label={`${product.discount} % Off`}
          size="small"
          sx={{
            position: "absolute",
            top: "10px",
            right: "10px",
            display: product.discount > 0 ? "flex" : "none",
            backgroundColor: "#e53935",
            color: "white",
            fontWeight: "bold",
            fontSize: "0.7rem",
          }}
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "140px",
            overflow: "hidden",
          }}
        >
          {product.images?.length > 0 &&
            product.images.map(
              (img, index) =>
                index === 0 && (
                  <img
                    key={index}
                    src={img.image_url}
                    alt={product.title}
                    style={{
                      maxHeight: "85%",
                      maxWidth: "85%",
                      objectFit: "contain",
                      cursor: "pointer",
                    }}
                    onClick={() => onImageClick(product, index)}
                  />
                ),
            )}
        </Box>
      </Box>

      <Box
        sx={{
          padding: "12px 16px",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 600,
            fontSize: "0.75rem",
            lineHeight: 1.3,
            mb: 0.5,
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 6,
            WebkitBoxOrient: "vertical",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            minHeight: `calc(0.75rem * 1.3 * 6)`,
          }}
        >
          {product.product_name && product.product_name != "null"
            ? product?.product_name
            : product?.name}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: "#666",
            mb: 1,
            fontWeight: 500,
            fontSize: "0.75rem",
          }}
        >
          {!isNaN(Number.parseFloat(product.stock_quantity))
            ? Number.parseFloat(product.stock_quantity)
            : 0}{" "}
          Units in stock
        </Typography>
        {/* Variant Dropdown */}
        {product.variantData && product.variantData.length > 0 ? (
          <Box sx={{ mb: 2 }}>
            {product.variantData.map((variant) => (
              <Box key={variant.variant_id} sx={{ mb: 2 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 400, mb: 1 }}>
                  {variant.title}
                </Typography>

                <Select
                  value={
                    selectedVariants[variant.variant_id]
                      ? JSON.stringify(selectedVariants[variant.variant_id])
                      : ""
                  }
                  onChange={handleVariantChange(
                    variant.variant_id,
                    product.variantData,
                  )}
                  fullWidth
                  displayEmpty
                  sx={{
                    borderRadius: "4px",
                    backgroundColor: "#f5f5f5",
                    padding: "4px 8px",
                    fontSize: "0.75rem",
                    height: "36px",
                  }}
                >
                  <MenuItem
                    value=""
                    disabled
                    sx={{ fontSize: "12px", padding: "8px" }}
                  >
                    {variant.options.length > 0
                      ? variant.options[0].option_name
                      : "Select Variant"}
                  </MenuItem>

                  {variant.options.map((option) => (
                    <MenuItem
                      key={option.variant_option_id}
                      value={JSON.stringify({
                        option_name: option.option_name,
                        variant_option_id: option.variant_option_id,
                      })}
                      sx={{ fontSize: "12px", padding: "8px" }}
                    >
                      {option.option_name}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            ))}
          </Box>
        ) : (
          <Typography
            variant="caption"
            sx={{
              color: "#999",
              mb: 2,
              fontSize: "0.75rem",
              fontStyle: "italic",
            }}
          ></Typography>
        )}

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 1,
          }}
        >
          <Box
            sx={{
              backgroundColor: "#388e3c",
              color: "white",
              borderRadius: "4px",
              padding: "0px 4px",
              display: "flex",
              alignItems: "center",
              fontSize: "0.7rem",
            }}
          >
            <Typography variant="caption" sx={{ fontWeight: 600, mr: 0.3 }}>
              {/* {product.rating} */}
              4.1
            </Typography>
            <Star sx={{ fontSize: "0.8rem" }} />
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            {
              !isAdded ? (
                <Button
                  variant="outlined"
                  sx={{
                    width: { xs: "100px", sm: "90px" },
                    color: buttonColor,
                    borderColor: buttonColor,
                    fontSize: "14px",
                    fontWeight: "bold",
                    textTransform: "none",
                    "&:hover": {
                      borderColor: "#FF6F00",
                      color: "#FF6F00",
                    },
                    "&:disabled": {
                      color: "#9e9e9e",
                      borderColor: "#9e9e9e",
                    },
                  }}
                  onClick={() => {
                    setIsAdded(true);
                    addProductToCart("", product, selectedVariants);
                  }}
                  disabled={product.stock_quantity <= 0}
                >
                  Add
                </Button>
              ) : (
                // (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #038100",
                    borderRadius: "5px",
                    overflow: "hidden",
                  }}
                >
                  <IconButton
                    sx={{ color: "#038100", padding: "4px 8px" }}
                    onClick={() => decreaseItem(product)}
                  >
                    <RemoveIcon />
                  </IconButton>
                  <Typography
                    sx={{
                      padding: "4px 16px",
                      backgroundColor: "#038100",
                      color: "#fff",
                      fontWeight: "bold",
                    }}
                  >
                    {count}
                  </Typography>
                  <IconButton
                    sx={{ color: "#038100", padding: "4px 8px" }}
                    onClick={() => increaseItem(product)}
                  >
                    <AddIcon />
                  </IconButton>
                </Box>
              )
              // )
            }
          </Box>
        </Box>
        <Box sx={{ mt: "auto", display: "flex", alignItems: "baseline" }}>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "1rem",
              color: "#000",
              mr: 1,
            }}
          >
            {/* ₹{Number.parseFloat(product.salePrice).toFixed(0)} */}₹
            {calculatedPrice.salePrice.toFixed(0)}
          </Typography>
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: "0.8rem",
              color: "#888",
              textDecoration: "line-through",
              mr: 1,
            }}
          >
            {/* ₹{Number.parseFloat(product.regularPrice).toFixed(0)} */}₹
            {calculatedPrice.regularPrice.toFixed(0)}
          </Typography>
        </Box>
      </Box>

      {/* <ProductCardWithZoom product={product} openModal={showProductZoomModal} onclose={(value)=>handleOnclose(value)} /> */}
    </Box>
  );
};

const ProductList = ({ slugid }) => {
  console.log("productslist", slugid);
  const location = useLocation();
  const [products, setProducts] = useState([]);
  const [cart, setCart] = useState([]);
  const dispatch = useDispatch();
  const latitude = useSelector(
    (state) => state.user?.userLocation?.latitude ?? null,
  );
  const longitude = useSelector(
    (state) => state.user.userLocation?.longitude ?? null,
  );
  const [vendors, setVendors] = useState([]);
  const apptoken = useSelector((state) => state?.user?.apptoken);
  const shop = location.state?.shop || slugid;
  const { slug } = useParams();
  // Extract the ID from the slug (assumes ID is after last hyphen)
  const slug_id = slug ? slug.split("-").pop() : undefined;

  console.log("shop and slug", shop, slug);
  const vendorProductsUrl =
    latitude && longitude
      ? `${BASE_URL_TEST}/api/vproducts/all?vendor_id=${slug_id}`
      : null;

  const {
    data: vendorProductsData,
    isLoading: isVendorProductsLoading,
    error,
    fetchData,
  } = useFetch(vendorProductsUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  useEffect(() => {
    console.log("vendorProductsData useEffect called");
    if (apptoken) {
      console.log("vendorProductsData Fetching vendor products with token:");
      fetchData();
    }
  }, [apptoken, latitude, longitude, slug_id]);

  useEffect(() => {
    if (vendorProductsData?.data) {
      // Filter only products with status === 1
      console.log("vendorProductsData", vendorProductsData?.data);
      const activeProducts = vendorProductsData.data
        .filter((item) => item.status === 1)
        .map((item) => ({
          ...item,
          title: item?.name ? item?.name : item?.product_name,
          quantity: item.quantity || "1 Unit",
          stockQuantity: isNaN(Number(item.stock_quantity))
            ? 0
            : Number(item.stock_quantity),
          price: item.salePrice,
          originalPrice: item.regularPrice,
          discount: `${Math.round(item.discount)}%`,
          rating: item.rating ?? 4.5,
          image: item.images?.slice(0, 3).map((img) => img.image_url) || [],
          variantData: item.variantData || [],
        }));

      setProducts(activeProducts);
    } else {
      console.log("vendorProductsData is undefined or has no data");
      setProducts([]);
    }
  }, [vendorProductsData]);

  useEffect(() => {
    if (vendorProductsData?.data) {
      // Filter the original data to include only products with status === 1
      const activeProducts = vendorProductsData.data.filter(
        (item) => item.status === 1,
      );

      // Set filtered products directly
      setProducts(activeProducts);
    } else {
      setProducts([]);
    }
  }, [vendorProductsData]);

  const [cartPopup, setCartPopup] = useState({
    open: false,
    item: "",
    price: 0,
    saved: 0,
    count: 0,
  });

  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const isSmallScreen = useMediaQuery("(max-width:767px)");
  const scroll = (direction) => {
    if (scrollRef.current) {
      const { scrollLeft, clientWidth } = scrollRef.current;
      const scrollAmount = clientWidth * 0.75;
      scrollRef.current.scrollTo({
        left:
          direction === "left"
            ? scrollLeft - scrollAmount
            : scrollLeft + scrollAmount,
        behavior: "smooth",
      });
    }
  };
  const handleItemAdded = (
    title,
    price,
    originalPrice,
    discount,
    image,
    quantity,
    selectedVariants = {},
  ) => {
    const numericPrice = parseFloat(price) || 0;
    const originalAmountprice = parseFloat(originalPrice) || 0;
    const numericQuantity = parseInt(quantity, 10) || 1;
    const variantOptionIdString = Object.values(selectedVariants)
      .map((v) => v.variant_option_id)
      .join(",");

    const selectedVariantDetails = Object.entries(selectedVariants).map(
      ([variant_id, { option_name, variant_option_id }]) => ({
        variant_id: Number(variant_id),
        option_name,
        variant_option_id,
      }),
    );
    setCartPopup({
      open: true,
      item: title,
      price: numericPrice,
      image: image[0],
      count: numericQuantity,
    });

    setCart((prevCart) => [
      ...prevCart,
      {
        title,
        price: numericPrice,
        originalPrice: originalAmountprice,
        image: image[0],
        count: numericQuantity,
        variantOptionId: variantOptionIdString,
        selectedVariants: selectedVariantDetails,
      },
    ]);

    dispatch(addProductToStore(cart));
  };
  // Modal popup state & handlers for product detail modal
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [clickedImageIndex, setClickedImageIndex] = useState(0);

  const handleImageClick = (product) => {
    setSelectedProduct(product);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedProduct(null);
  };
  // Modal component for product detail with images carousel
  const ProductDetailModal = ({ open, onClose, product, initialIndex }) => {
    const [currentImgIndex, setCurrentImgIndex] = useState(initialIndex || 0);
    console.log("product", product);
    //  useEffect(() => {
    //    console.log("fdfd",currentImgIndex);
    //   if (product && open) {
    //     setCurrentImgIndex(initialIndex || 0);

    //   }
    // }, [open, product, initialIndex]);

    //   useEffect(() => {
    //   if (product && open) {
    //     setCurrentImgIndex(initialIndex ?? 0); // reset to clicked image or default 0
    //   }
    // }, [open, product, initialIndex]);

    if (!product) return null;

    const images = product.images || [];

    const handlePrev = () => {
      setCurrentImgIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    const handleNext = () => {
      setCurrentImgIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };

    return (
      <>
        {selectedProduct && (
          <Modal open={open} onClose={onClose}>
            <Box
              sx={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: { xs: "90%", sm: "70%", md: "50%" },
                bgcolor: "background.paper",
                boxShadow: 24,
                borderRadius: "12px",
                display: "flex",
                p: 4,
                outline: "none",
                maxHeight: "80vh",
              }}
            >
              {/* Left side: image carousel */}
              <Box
                sx={{
                  width: "60%",
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {images[currentImgIndex] ? (
                  <>
                    <IconButton
                      onClick={handlePrev}
                      sx={{
                        position: "absolute",
                        left: 0,
                        top: "50%",
                        transform: "translateY(-50%)",
                        bgcolor: "rgba(0,0,0,0.3)",
                        color: "white",
                        zIndex: 10,
                      }}
                    >
                      <ArrowBackIos />
                    </IconButton>

                    <img
                      src={images[currentImgIndex].image_url}
                      alt={`${product.name} ${currentImgIndex + 1}`}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "80vh",
                        borderRadius: "8px",
                        objectFit: "contain",
                      }}
                    />

                    <IconButton
                      onClick={handleNext}
                      sx={{
                        position: "absolute",
                        right: 0,
                        top: "50%",
                        transform: "translateY(-50%)",
                        bgcolor: "rgba(0,0,0,0.3)",
                        color: "white",
                        zIndex: 10,
                      }}
                    >
                      <ArrowForwardIos />
                    </IconButton>
                  </>
                ) : (
                  <Typography>No images available</Typography>
                )}
              </Box>

              {/* Right side: product details */}
              <Box
                sx={{
                  flex: 1,
                  pl: 3,
                  overflowY: "auto",
                  maxHeight: "80vh",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography variant="h6" fontWeight="bold" mb={2}>
                  {selectedProduct.name}
                </Typography>

                <Typography variant="h5" color="primary" mb={1}>
                  ₹{selectedProduct.salePrice}
                </Typography>
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  sx={{ textDecoration: "line-through" }}
                >
                  ₹{selectedProduct.regularPrice}
                </Typography>

                <Box sx={{ mt: "auto" }}>
                  <Button variant="contained" onClick={onClose}>
                    Close
                  </Button>
                </Box>
              </Box>
            </Box>
          </Modal>
        )}
      </>
    );
  };

  return (
    <Box
      sx={{
        width: "100%",
        padding: "2rem",
        backgroundColor: "#f5f5f5",
      }}
    >
      {products.length > 0 ? (
        <>
          {/* Group Products by Category */}
          {Object.values(
            products.reduce((acc, product) => {
              const category = product.category_name || "Other";
              if (!acc[category]) acc[category] = [];
              acc[category].push(product);
              return acc;
            }, {}),
          ).map((categoryProducts, index) => (
            <Box key={index} sx={{ marginBottom: "3rem" }}>
              {/* Category Title */}
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  marginBottom: "1.5rem",
                  borderLeft: "5px solid #4caf50",
                  paddingLeft: "10px",
                  textTransform: "capitalize",
                }}
              >
                {categoryProducts[0]?.category_name}
              </Typography>

              {/* 5 Products Per Row */}
              <Grid container spacing={3}>
                {categoryProducts.map((product, i) => (
                  <Grid item xs={12} sm={6} md={4} lg={2.4} key={i}>
                    <ProductCard
                      product={product}
                      key={product.product_id}
                      onItemAdded={handleItemAdded}
                      onImageClick={() => handleImageClick(product)}
                    />
                    {/* Product Detail Modal */}
                    {selectedProduct && (
                      <ProductDetailModal
                        open={modalOpen}
                        onClose={handleCloseModal}
                        product={selectedProduct}
                        //initialIndex={clickedImageIndex}
                      />
                    )}
                  </Grid>
                ))}
              </Grid>
            </Box>
          ))}
        </>
      ) : (
        <Box
          sx={{
            padding: "2rem",
            textAlign: "center",
            color: "#888",
            fontSize: "1rem",
            fontWeight: 700,
          }}
        >
          No products available.
        </Box>
      )}

      {/* Existing Cart Popup (UNCHANGED) */}
      {cartPopup.open && (
        <Box
          sx={{
            position: "fixed",
            bottom: "16px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#fff",
            border: "1px solid #ddd",
            boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
            padding: "16px",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            maxWidth: "800px",
            zIndex: 1300,
          }}
        >
          <Box sx={{ flex: "1" }}>
            <Typography
              sx={{ fontSize: "14px", fontWeight: "bold", marginBottom: "8px" }}
            >
              {cartPopup.count} {cartPopup.count > 1 ? "Item(s)" : "Item"} added
              to cart
            </Typography>
            {typeof cartPopup.price === "number" && (
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  marginBottom: "8px",
                }}
              >
                Total Price: ₹{cartPopup.price.toFixed(2)}
              </Typography>
            )}
          </Box>

          <Button
            variant="contained"
            sx={{
              backgroundColor: "#ff5722",
              color: "#fff",
              fontWeight: "bold",
              textTransform: "none",
              borderRadius: "8px",
              "&:hover": {
                backgroundColor: "#e64a19",
              },
            }}
            onClick={() => navigate("/cart")}
          >
            Go to Cart
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default ProductList;
